import axiosClient from "utils/axios";
import { ApiResponse } from "types/api.types";
import type {
  CreateGoodsReceiptPayload,
  GoodsReceipt,
} from "../types/goods-receipt.types";

export const createGoodsReceipt = async (
  purchaseOrderId: number,
  payload: CreateGoodsReceiptPayload,
) => {
  const response = await axiosClient.post<ApiResponse<GoodsReceipt>>(
    `/purchase-orders/${purchaseOrderId}/goods-receipts`,
    payload,
  );
  return response.data;
};

export const getGoodsReceipt = async (id: number) => {
  const response = await axiosClient.get<ApiResponse<GoodsReceipt>>(
    `/goods-receipts/${id}`,
  );
  return response.data;
};
